import { render } from "./AlertsContent.vue?vue&type=template&id=7cf8b7f2&ts=true"
import script from "./AlertsContent.vue?vue&type=script&lang=ts"
export * from "./AlertsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__